import React, { useState, useEffect } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'

const Logout = () => {

   


    let key = sessionStorage.getItem('key')
    const [logoutSuccess, setLogoutSuccess] = useState(false)

   
    fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Logout?key=${key}`, {
        method: "GET",
        headers: {
            'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
        .then((res) => res.json())
        .then(result => {

            if (result.result === 1) {
                sessionStorage.removeItem('login_info')
                sessionStorage.removeItem('login_pw')
                sessionStorage.removeItem('key')
                setLogoutSuccess(true)

               
             

            }
        })

   // document.getElementsByTagName('body')[0].style.backgroundColor = 'black'
    return (
        < div className='login-profile' style={{ marginTop: '-15px' }}>

            {logoutSuccess === true ? 

                <h3 style={{ fontSize: '36px', color: 'white', fontFamily:'oswald' }}>Du er nu logget ud!</h3> : null}
        </div>
    )
}

export default Logout